import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask'
})
export class MaskPipe implements PipeTransform {

  transform(value: string, type: string): string {
    if (!value) return value;

    switch (type) {
      case 'name':
        return value.replace(/.(?=.{1,}$)/g, '*');
      case 'phone':
        return value.replace(/.(?=.{2})/g, '*');
      case 'email':
        const [name, domain] = value.split('@');
        return `${name[0]}*****@${domain}`;
      default:
        return value;
    }
  }
}
